import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className,
  hover = false
}: CardProps) {
  return <motion.div whileHover={hover ? {
    y: -5
  } : undefined} className={cn('bg-white rounded-2xl shadow-sm border border-[#EAE0D5] p-6 md:p-8', className)} data-id="element-212">
      {children}
    </motion.div>;
}